// extracted by mini-css-extract-plugin
module.exports = {"root":"InformationAboutAdvertisementText_root__2xIeg"};